<template>
   
    <vs-popup style="z-index: 99999;" title="Detaylar" fullscreen :active.sync="variantPopupLocal">
        <vs-row vs-type="flex" vs-w="12" class="mt-1" v-if="Object.keys(variantSums).length > 0">
            <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <vs-row vs-type="flex" vs-w="12" v-for="size in variantSums" :key="size.sizeId"
                    class="border-all border-secondary py-1 px-2 border-radius text-smaller my-1">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row vs-type="flex" vs-w="12" class="border-bottom">
                      <vs-col vs-type="flex" vs-w="4">
                        <span class="text-primary bold">{{ size.sizeName }}</span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="4">
                      <span>
                        Adet
                      </span>
                      </vs-col>
                      <vs-col vs-type="flex" vs-w="4">
                      <span>
                        Tutar
                      </span>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" v-for="variant in size.variants" :key="variant.variantId" class="my-1">
                <vs-col vs-type="flex" vs-w="4">
                  <span class="weight-600">
                    {{ variant.variantName }}
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ variant.variantPiece.toLocaleString() }}
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span>
                    {{ $convertCurrency(variant.variantAmount) }}
                  </span>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="mt-1">
                <vs-col vs-type="flex" vs-w="4">
                  <span class="text-primary bold">
                    Toplam
                  </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                <span class="weight-500">
                  {{ size.sizePiece.toLocaleString() }}
                </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <span class="bold">
                    {{ $convertCurrency(size.sizeAmount) }}
                  </span>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-row>
          </vs-row>
     </vs-popup>
   </template>
   
   <script>
   export default {
     props: {
        variantPopup: {
         type: Boolean,
         required: true
       },
       variantSums: {
      required: true,
      type: Object,
    }
     },
     components: {
   },
     
   
   computed: {
    variantPopupLocal: {
         get() {
           return this.variantPopup;
         },
         set(val) {
           if (!val) {
             this.$emit("close");
           }
         }
       }
   },
   }
   </script>